<template>
<v-layout align-center justify-center class="pagemargin page">
  <div class="error-page">
    <div v-if="user.emailVerified == true">
      <p data-h1="404">404</p>
      <p data-p="forbidden">ACCESS FORBIDDEN</p>
    </div>
    <div v-else>
      <p data-p="forbidden">Please verify your email!</p>
      <br/>
      <v-btn
        round
        block
        color="primary"
        :disabled="errors.any()"
        @click="resendEmail"
        class="caption font-weight-light"
      >Send Email</v-btn>
    </div>
  </div>
</v-layout>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import Axios from "axios";
import store from "@/store/index";

export default {
  name: "no-access",
  computed: {
    ...mapState({
      user: state => state.user.active,
      portal: state => state.portal,
      FirebaseFunctionsURL: state => state.FirebaseFunctionsURL
    })
  },
  methods: {
    resendEmail: function() {
      //console.log("userID = " + this.user.userID);
      Axios.get(
        this.FirebaseFunctionsURL +
          "resendVerificationEmail?userID=" +
          this.user.userID +
          "&pid=" +
          this.portal.active.id
      ).then(response => {
        //console.log("RESULT: " + JSON.stringify(response, null, 2));
        // if (response.data.result === true) // console.log("Email resent");
        // else // console.log("The email was not sent");
      });
    }
  }
};
</script>

<style>
.error-page {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  margin: 10%;
}
.error-page p {
  font-size: 10vh;
  font-weight: bold;
  position: relative;
  margin: -7vh 0 0;
  padding: 0;
}
.error-page p:after {
  content: attr(data-h1);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: transparent;
  /* webkit only for graceful degradation to IE */
  background: -webkit-repeating-linear-gradient(
    -45deg,
    #71b7e6,
    #69a6ce,
    #b98acc,
    #ee8176,
    #b98acc,
    #69a6ce,
    #9b59b6
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 400%;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.25);
  animation: animateTextBackground 10s ease-in-out infinite;
}
.error-page p {
  color: #d6d6d6;
  font-size: 8vh;
  font-weight: bold;
  line-height: 10vh;
  max-width: 600px;
  position: relative;
  margin: 2%;
}
.error-page h1 + p:after {
  content: attr(data-p);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: transparent;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
}

@keyframes animateTextBackground {
  0% {
    background-position: 0 0;
  }
  25% {
    background-position: 100% 0;
  }
  50% {
    background-position: 100% 100%;
  }
  75% {
    background-position: 0 100%;
  }
  100% {
    background-position: 0 0;
  }
}
@media (max-width: 767px) {
  .error-page h1 {
    font-size: 32vw;
  }
  .error-page h1 + p {
    font-size: 8vw;
    line-height: 10vw;
    max-width: 70vw;
  }
}
</style>